import { render, staticRenderFns } from "./DoctorPriceBlock.vue?vue&type=template&id=0ed1e3ce&"
import script from "./DoctorPriceBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPriceBlock.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed1e3ce')) {
      api.createRecord('0ed1e3ce', component.options)
    } else {
      api.reload('0ed1e3ce', component.options)
    }
    module.hot.accept("./DoctorPriceBlock.vue?vue&type=template&id=0ed1e3ce&", function () {
      api.rerender('0ed1e3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPriceBlockV2/DoctorPriceBlock.vue"
export default component.exports